import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class Capacitaciones_ClientesParticipantesService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  index(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ClientesParticipantes/Index", null, Sessions.header());
  }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ClientesParticipantes/DataSource", varArgs, Sessions.header());
  }

  store(objCapacitacion_ClienteParticipante : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ClientesParticipantes/Store", objCapacitacion_ClienteParticipante, Sessions.header());
  }

  update(objCapacitacion_ClienteParticipante : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ClientesParticipantes/Update", objCapacitacion_ClienteParticipante, Sessions.header());
  }

  delete(objCapacitacion_ClienteParticipante : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ClientesParticipantes/Delete", objCapacitacion_ClienteParticipante, Sessions.header());
  }

}